import React from 'react';
import { useQuery } from '@apollo/client';
import { readOneFixedAsset } from './api';
import EquipCodeDropdown from './EquipCodeDropdown';
import PhysicalOwnerDropdown from './PhysicalOwnerDropdown';

interface Props {
  data: any;
  disableFields: boolean;
  toTransfer: boolean;
  formik: any;
}

const AdditionalTransferFields = (props: Props) => {
  const { data, loading, error } = useQuery(readOneFixedAsset, {
    variables: { barcode: props.data.verificationById.BarCodeNumber },
  });

  if (loading) return null;
  if (error) {
    console.log('Error: /frontend/src/components/VerificationForms/AdditionalTransferFields//index', error);
    return null;
  }

  if (props.toTransfer) {
    return (
      <div>
        <PhysicalOwnerDropdown data={data.readOneFixedAsset.physicalOwner} formik={props.formik} disableFields={props.disableFields} />

        <EquipCodeDropdown /* data={data.readOneFixedAsset.equipmentStatus} */ formik={props.formik} disableFields={props.disableFields} />

        <div className='form-group form-inline'>
          <label className='col-sm-3'>Transfer To</label>
          <input
            disabled={props.disableFields}
            id='transferTo'
            name='transferTo'
            className='form-control col-sm-8'
            onChange={props.formik.handleChange}
            value={props.formik.values.transferTo}
          />
        </div>
      </div>
    );
  }

  return null;
};

export default AdditionalTransferFields;
